var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsunami(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.887 20C10.962 18.385 12 16.659 12 14.823c0-2.755-1.153-6.472-4.345-6.472-3.191 0-3.155 2.066-3.155 2.795 0 .73.634 1.091 1.094 1.091.46 0 .453-.593 1.47-.593 1.016 0 2.462.56 2.462 2.526 0 1.967-1.656 2.726-3.175 2.726-1.52 0-4.351-1.02-4.351-5.252C2 7.412 4.49 5 8.682 5c4.193 0 5.919 4.582 7.23 6.958.875 1.585 2.904 4.265 6.088 8.042H8.887z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsunami);
export default __webpack_public_path__ + "static/media/tsunami.452c017dd17d93ce5e49629ceb250c09.svg";
export { ForwardRef as ReactComponent };